<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span
                class="fa fa-table"></span>{{ 'bikeshop.menu.affiliates_commission' | translate }}
        </div>
        <!-- <div class="loading" *ngIf="loading || runningReport">
          <div class="loader"></div>
        </div> -->
    </div>
    <div class="content">

        <div class="filter row">
            <div class="col-md-3">
                <div class="label">{{ 'bikeshop.rentals.affiliates.select_affiliates' | translate }}:</div>
                <p-multiSelect [options]="affiliates" [(ngModel)]="selectedAffiliates" [maxSelectedLabels]="1"
                               [showToggleAll]="true" [filter]="" false></p-multiSelect>
            </div>
            <div class="col-md-3">
                <div class="label">{{ 'bikeshop.report.from_date' | translate }}:</div>
                <p-calendar [(ngModel)]="startDate" [showButtonBar]="false" [showIcon]="true" [readonlyInput]="true"
                            dateFormat="dd MM yy"></p-calendar>
            </div>
            <div class="col-md-3">
                <div class="label">{{ 'bikeshop.report.to_date' | translate }}:</div>
                <p-calendar [(ngModel)]="endDate" [showButtonBar]="false" [showIcon]="true" [readonlyInput]="true"
                            dateFormat="dd MM yy"></p-calendar>
            </div>
            <div class="col-md-2">
                <button pButton style="margin-top:16px;" type="button" class="full-width p-button-raised"
                        label="{{ 'bikeshop.rentals.affiliates.get_affiliate_commission' | translate }}"
                        (click)="getAffiliateCommisionPayments()" [disabled]="!valid()"></button>
            </div>
            <div class="col-md-1">
                <div *ngIf="affiliateCommssionPayments && affiliateCommssionPayments.length > 0">
          <span style="position: absolute;top: 45%;left: 30%; cursor: pointer;" (click)="downloadFile()"><i
                  class="fa fa-download fa-2x" aria-hidden="true"></i></span>
                </div>
            </div>
        </div>

        <div *ngIf="runningReport" class="margin-top-16">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
        </div>

        <div class="margin-top-16">
            <div *ngIf="affiliates && affiliates.length > 0">
                <p-table #affiliateCommssionPaymentsTable [value]="affiliateCommssionPayments">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th>{{ 'bikeshop.rentals.affiliates.affiliate_name' | translate }}</th>
                            <th style="width: 220px">{{ 'bikeshop.rentals.affiliates.period' | translate }}</th>
                            <th>{{ 'bikeshop.rentals.affiliates.reference_number' | translate }}</th>
                            <th>{{ 'bikeshop.rentals.affiliates.rentals_total' | translate }}</th>
                            <th>{{ 'bikeshop.rentals.affiliates.commission_total' | translate }}</th>
                            <th>{{ 'bikeshop.rentals.affiliates.commission' | translate }}</th>
                            <th>{{ 'bikeshop.rentals.affiliates.linked_reservations' | translate }}</th>
                            <th>{{ 'bikeshop.rentals.affiliates.paid' | translate }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-affiliatePayment let-columns="columns">
                        <tr>
                            <td>{{affiliatePayment.affiliateName}}</td>
                            <td>{{affiliatePayment.fromDate | date : countryData.AngularDateFormat}}
                                - {{affiliatePayment.toDate | date : countryData.AngularDateFormat}}</td>
                            <td>{{affiliatePayment.referenceNumber}}</td>
                            <td>{{affiliatePayment.rentalsTotal | currency : partner.CurrencySymbol}}</td>
                            <td>{{affiliatePayment.commissionAmount | currency : partner.CurrencySymbol}}</td>
                            <td>{{affiliatePayment.commissionPercentage.toFixed(2)}}%</td>
                            <td>
                <span *ngFor="let reservation of affiliatePayment.linkedReservations;let i=index;">
                  #{{reservation.reservationNumber}}{{i < affiliatePayment.linkedReservations.length - 1 ? ", " : ""}}
                </span>
                            </td>
                            <td>
                                <div *ngIf="affiliatePayment.paid">{{'general.yes' | translate}}</div>
                                <div *ngIf="!affiliatePayment.paid">
                                    <div *ngIf="!affiliatePayment.busy">
                                        <button pButton type="button" (click)="markAsPaid(affiliatePayment)"
                                                class="p-button-raised full-width p-mini"
                                                label="{{ 'bikeshop.rentals.affiliates.mark_as_paid' | translate}}"></button>
                                    </div>
                                    <div *ngIf="affiliatePayment.busy">
                                        <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                                           animationDuration=".5s"></p-progressSpinner>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div *ngIf="(!affiliates || affiliates.length === 0) && !loadingAffiliates" class="empty-state">
                <div class="empty-state-icon"><span class="fa fa-building-o"></span></div>
                <div class="empty-state-header">{{ 'bikeshop.rentals.affiliates.empty_state_header' | translate }}</div>
            </div>
        </div>

    </div>

</div>
